import React from 'react'
import { Link } from '~/code/components'
import translations from './translations'

translations.add('pt', {
    timeLeftToFinishPayment: (seconds: number) => <>Tem <Link hasUnderline={ false } inline={ true } isNotClickable={true}>{seconds}</Link> segundos restantes para concluir o pagamento.</>
})
